import React, { Component } from "react"
import PropTypes from "prop-types"
import { bindAll } from "utils"


const toArray = children => {
  if (typeof children === "object") {
    return Object.values(children)
  }
  return children
}

class SteppedFlow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      steps: props.children.length,
      activeStepIndex: 0
    }
    bindAll(["changeStep", "setStep"], this)
  }

  changeStep(dir) {
    const stepIndex = this.state.activeStepIndex + dir
    this.setStep(stepIndex)
  }

  setStep(ref) {
    let index = ref

    if (typeof ref === "string") {
      index = Object.keys(this.props.children).indexOf(ref)
    }

    if (index > this.state.steps - 1 || index < 0) return

    this.setState({ activeStepIndex: index })
  }

  render() {
    const activeStep = toArray(this.props.children)[this.state.activeStepIndex]

    if (!activeStep || typeof activeStep !== "function") {
      return null
    }

    return activeStep({
      index: this.state.activeStepIndex,
      setStep: this.setStep,
      nextStep: () => this.changeStep(1),
      prevStep: () => this.changeStep(-1),
      isEnd: this.state.steps - 1 === this.state.activeStepIndex
    })
  }
}

SteppedFlow.propTypes = {
  children: PropTypes.arrayOf(PropTypes.func)
}

export default SteppedFlow



// WEBPACK FOOTER //
// ./src/components/stepped-flow/index.jsx